module.exports = __webpack_public_path__ + "img/section4_pic2@2x.6c7da1c7.png";